import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const ecomAdditionalInfoViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map